import { SearchClient } from 'algoliasearch';
import { searchClient } from './searchClient';

// Initialize the base Algolia search client using environment variables
const baseSearchClient = searchClient;

// Utility to check if highlight tags are present in the search parameters
const allowOnlyHighlightTag = (params?: Record<string, any>): boolean => {
  return !!params?.highlightPreTag;
};

// Extend the search client with a wrapper to handle empty queries and enforce highlighting rule
export const searchClientWithEmptyCheck: SearchClient = {
  ...baseSearchClient,

  // Override the `search` method
  search(requests: any[]) {
    // Check if all queries are empty or just whitespace
    const isEmptyQuery = requests?.every((r) => !r?.params?.query?.trim());

    if (isEmptyQuery) {
      // Return dummy results when the query is empty
      return Promise.resolve({
        results:
          requests?.map(() => ({
            hits: [],
            nbHits: 0,
            page: 0,
            nbPages: 0,
            hitsPerPage: 24,
            exhaustiveNbHits: false,
            query: '',
            params: '',
            processingTimeMS: 0,
          })) ?? [],
      });
    }

    // Check if all requests include valid highlight tags
    const hasValidHighlightRequests = requests?.every((r) => allowOnlyHighlightTag(r?.params));

    if (!hasValidHighlightRequests) {
      // If any request is missing highlight tags, return empty result
      return Promise.resolve({
        results:
          requests?.map(() => ({
            hits: [],
            nbHits: 0,
            page: 0,
            nbPages: 0,
            hitsPerPage: 24,
            exhaustiveNbHits: false,
            query: '',
            params: '',
            processingTimeMS: 0,
          })) ?? [],
      });
    }

    // If all checks pass, proceed with the original search request
    return baseSearchClient.search(requests);
  },
};
